export default __webpack_public_path__ + "static/yash-sharma-layer5-meshmate-8ecc9bd193485201ad482605d3c69c00.png";